import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboardIcon, HistoryIcon, BeakerIcon, ArchiveIcon, ActivityIcon, BellIcon, BuildingIcon, FileTextIcon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
interface SidebarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
}
const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  toggleSidebar
}) => {
  const location = useLocation();
  const {
    theme
  } = useTheme();
  const logoUrl = theme === 'dark' ? 'https://uploadthingy.s3.us-west-1.amazonaws.com/wBdzqvYep3H7EZM765Vtit/Polify_Logo_Design_Alert_Icon-10.png' : 'https://uploadthingy.s3.us-west-1.amazonaws.com/2XS892V2VB9BJkiBub4kpC/Polify_Logo_Design_Alert_Icon-04.png';
  const navItems = [{
    name: 'Dashboard',
    path: '/',
    icon: <LayoutDashboardIcon size={20} data-id="element-289" />,
    description: 'View main dashboard with scraper status'
  }, {
    name: 'Payers',
    path: '/payers',
    icon: <BuildingIcon size={20} data-id="element-290" />,
    description: 'Manage payer information and sources'
  }, {
    name: 'Policies',
    path: '/policies',
    icon: <FileTextIcon size={20} data-id="element-291" />,
    description: 'View and manage policy documents'
  }, {
    name: 'History',
    path: '/history',
    icon: <HistoryIcon size={20} data-id="element-292" />,
    description: 'View historical scraper data'
  }, {
    name: 'Testing',
    path: '/testing',
    icon: <BeakerIcon size={20} data-id="element-293" />,
    description: 'Test and validate scrapers'
  }, {
    name: 'Archives',
    path: '/archives',
    icon: <ArchiveIcon size={20} data-id="element-294" />,
    description: 'Access archived scraper data'
  }, {
    name: 'Monitoring',
    path: '/monitoring',
    icon: <ActivityIcon size={20} data-id="element-295" />,
    description: 'Monitor real-time scraper activity'
  }, {
    name: 'Notifications',
    path: '/notifications',
    icon: <BellIcon size={20} data-id="element-296" />,
    description: 'View system notifications and alerts'
  }];
  // Always use collapsed state (w-20)
  return <aside className={`w-20 transition-all duration-300 ease-in-out ${theme === 'dark' ? 'bg-gray-800 border-r border-gray-700' : 'bg-white border-r border-gray-200'}`} data-id="element-297">
      <div className="h-full flex flex-col" data-id="element-298">
        <div className="flex items-center justify-center p-4 border-b border-gray-700/50" data-id="element-299">
          <div className="flex items-center justify-center" data-id="element-300">
            <img src={logoUrl} alt="Polify Logo" className="h-8 w-auto" data-id="element-301" />
          </div>
        </div>
        <nav className="flex-1 pt-4" data-id="element-302">
          <ul data-id="element-303">
            {navItems.map(item => {
            const isActive = location.pathname === item.path;
            return <li key={item.name} data-id="element-304">
                  <Link to={item.path} className={`flex flex-col items-center py-3 px-2 justify-center ${isActive ? theme === 'dark' ? 'bg-fuchsia-900/30 text-fuchsia-400 border-r-4 border-fuchsia-500' : 'bg-fuchsia-50 text-fuchsia-700 border-r-4 border-fuchsia-500' : theme === 'dark' ? 'text-gray-400 hover:bg-gray-700/50 hover:text-white' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'}`} title={item.description} data-id="element-305">
                    <span className="flex-shrink-0" data-id="element-306">{item.icon}</span>
                    <span className="text-[8px] mt-1 uppercase tracking-tight font-light" data-id="element-307">
                      {item.name}
                    </span>
                  </Link>
                </li>;
          })}
          </ul>
        </nav>
        <div className={`p-4 mt-auto ${theme === 'dark' ? 'border-t border-gray-700/50 text-gray-400' : 'border-t border-gray-200 text-gray-600'}`} data-id="element-308">
          <div className="flex justify-center" data-id="element-309">
            <ActivityIcon size={18} data-id="element-310" />
          </div>
        </div>
      </div>
    </aside>;
};
export default Sidebar;